<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon v-if="isReader" icon="PrinterIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="viewRecord"  />
      <feather-icon v-if="canEdit && isWriter" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord"  />
      <feather-icon v-if="canSubmit" icon="CheckCircleIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openSubmissionConfirm" />
      <feather-icon v-show="canDelete && isWriter" icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openDeleteConfirm"/>
    </div>
</template>

<script>
import kpuRoles from './../roles.js'
export default {
  name: 'KpuActionsCellRenderer',
  computed: {
    canEdit() {
      return !this.params.data.isInProgress || this.params.data.modifiedBy === this.$auth.getUser().username || this.$auth.checkRoles(kpuRoles.admins);
    },
    canSubmit() {
      return this.params.data.isInProgress && (this.params.data.modifiedBy === this.$auth.getUser().username || this.$auth.checkRoles(kpuRoles.admins));
    },
    canDelete() {
      return this.params.data.isInProgress && (this.params.data.modifiedBy === this.$auth.getUser().username || this.$auth.checkRoles(kpuRoles.admins));
    },
    isWriter() {
      return this.$auth.checkRoles(kpuRoles.collaborators);
    },
    isReader() {
      return this.$auth.checkRoles(kpuRoles.readers);
    }
  },
  methods: {
    editRecord () {
      this.params.context.componentParent.editData(this.params.data);
    },
    viewRecord () {
      this.params.context.componentParent.viewData(this.params.data);
    },

    openSubmissionConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('KPU.ConfirmSubmission'),
        accept: this.submitStatement
      });
    },

    openDeleteConfirm() {
      this.$deleteConfirmation({
        text: this.$t('KPU.ConfirmDelete'),
        accept: this.deleteRecord
      });
    },

    deleteRecord () {
      this.params.context.componentParent.deleteData(this.params.data.id);
    },
    submitStatement () {
      this.params.context.componentParent.submitStatement(this.params.data.id);
    }
  }
}
</script>
